<app-orders-table 
[dataSource]="dataSource" 
[orderState]="OrderStateEnum.InProgress" 
[warehouses]="warehouses"
[businesses]="businesses"
[displayedColumns]="tableColumns"
(tableActionTaken)="handleTableAction($event)">
</app-orders-table>